import $ from 'jquery';
import {
  valdnTextRequired,
  valdnTextMinMaxRequired,
  valdnUserPw,
  valdnEmailRequired,
  valdnTelRequired,
  debounce
} from '../lib/customValidator'
import {
  onloadCallback
} from '../lib/recaptchaCallback'
import {
  DOMDataCache
} from '../lib/DOMDataCache';

if (typeof window !== 'undefined') {
  Object.assign(window, {
    onloadCallback
  });

  const script = document.createElement('script');
  script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallback&render=explicit&hl=en';
  script.async = true;
  script.defer = true;
  //script.crossOrigin = 'anonymous';
  document.body.appendChild(script);
}



$(function () {
  const cache = new DOMDataCache();
  const formElement = cache.getOrSetElement('#signupForm');
  const newPwElement = cache.getOrSetElement('#newPw');
  const repeatNewPwElement = cache.getOrSetElement('#repeatNewPw');
  const submitBtnElement = cache.getOrSetElement('.btn-submit', formElement);

  cache.set("inputRequiredCount", formElement.find("input[required]").length);

  function checkFormValid() {
    const hasInvalid = formElement.find('.unfit').length > 0;

    if (hasInvalid) {
      submitBtnElement.prop("disabled", true);
      return;
    }

    const needValidCount = cache.get('inputRequiredCount');
    const validCount = formElement.find(".fit").length;

    if (needValidCount === validCount) {
      submitBtnElement.prop("disabled", false);
      return;
    }
    submitBtnElement.prop("disabled", true);
  }

  function controlFitIcon(wrapperElement, valdnResult) {
    // 減少 dom rerender, 因為偽元素根據 cl插入跟刪除都會觸發 rerender
    if (valdnResult) {
      if (wrapperElement.hasClass('unfit')) {
        wrapperElement.removeClass('unfit')
      }
      if (!wrapperElement.hasClass('fit')) {
        wrapperElement.addClass('fit');
      }
    } else {
      if (wrapperElement.hasClass('fit')) {
        wrapperElement.removeClass('fit');
      }

      if (!wrapperElement.hasClass('unfit')) {
        wrapperElement.addClass('unfit');
      }
    }
  }

  const debounceVald = debounce(function (e) {
    formValueVald($(this));
  }, 150);


  // 💡 將整個驗證流程，包含 DOM 操作與最終檢查，都放入 debounce 函數
  const formValueVald = function (el) {
    const inputEl = el;
    let valdnResult = false;
    let inputVal = inputEl.val();
    let lengthMin = (inputEl.attr('minlength') === undefined || inputEl.attr('minlength') <= 0) ? parseInt(-1, 10) : parseInt(inputEl.attr('minlength'), 10);
    let lengthMax = (inputEl.attr('maxlength') === undefined || inputEl.attr('maxlength') <= 0) ? parseInt(-1, 10) : parseInt(inputEl.attr('maxlength'), 10);

    // console.log('min: ' + lengthMin + ' max: ' + lengthMax);

    const wrapperCacheKey = "#" + inputEl.attr('id') + "Wrapper";
    let wrapperEl = cache.get(wrapperCacheKey); // .input-wrapper 或 .pw-wrapper
    if (!wrapperEl) {
      wrapperEl = inputEl.parent();
      cache.set(wrapperCacheKey, wrapperEl);
    }

    // 根據 ID 執行對應的驗證邏輯
    switch (inputEl.attr('id')) {
      case 'userName':
        valdnResult = valdnTextMinMaxRequired(inputVal, lengthMin, lengthMax);
        break;
      case 'userAffiliation':
        valdnResult = valdnTextMinMaxRequired(inputVal, lengthMin, lengthMax);
        break;
      case 'newPw':
        valdnResult = valdnUserPw(inputVal);
        // 當新密碼變動時，也觸發確認密碼的驗證，確保狀態一致
        // 注意：這裡的 trigger 會立即執行另一個 input 事件，但因為整個流程是 debounced，所以不會有問題
        if (repeatNewPwElement.val() !== '') {
          repeatNewPwElement.trigger('input');
        }
        break;
      case 'repeatNewPw':
        valdnResult = valdnUserPw(inputVal) && (inputEl.val() === newPwElement.val());
        break;
      case 'userEmail':
        valdnResult = valdnEmailRequired(inputVal);
        break;
      case 'userPhone':
        valdnResult = valdnTelRequired(inputVal);
        break;
    }

    controlFitIcon(wrapperEl, valdnResult);
    checkFormValid(); // 驗證完欄位後，立即檢查整體表單狀態
  };

  // 🎯 input 事件觸發時，只呼叫 debounced 函數
  formElement.on('input', '#userName, #userAffiliation, #newPw, #repeatNewPw, #userEmail, #userPhone', debounceVald);

  // 密碼顯示/隱藏開關
  formElement.on('click', '.pw-switch', function () {
    let switchElement = $(this);
    let inputElement = switchElement.siblings('input');

    if (switchElement.hasClass('active')) {
      switchElement.removeClass('active');
      inputElement.attr("type", "password");
      return;
    }
    switchElement.addClass('active');
    inputElement.attr("type", "text");
  });

  document.title = $('#page-title').text();

  /** 初始語系 */
  fetch('/api/profile/lang.php')
    .then(response => response.json())
    .then(result => {
      if (result.status === "success") {
        const lang = result.data.lang;

        $(`select.lang-option option[value='${lang}']`).prop("selected", true);
      }
    })
    .catch(error => {
      console.error('API 請求失敗:', error);
    });

  /* 語系變更 */
  $('.lang-option').on('change', function () {
    var selectedLang = $(this).val();
    var csrfToken = $(this).siblings('input[name="csrf_token"]').val();

    fetch('/language_setting.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        "language": selectedLang,
        "csrf_token": csrfToken
      })
    })
      .then(res => res.json())
      .then(() => {
        window.location.reload();
      })
      .catch(err => {
        console.error('Language setting failed:', err);
      });
  });

  /* 提交表單時暫時停用 submit按鈕 */
  $('body').on('submit', '.form-valdn', function (e) {
    let $form = $(this),
      $formElement = $form.find('input[required]');
    let $btn = $(this).find('.btn-submit');

    if ($form.data('isSubmitting') === true || $btn.prop('disabled') === true) {
      e.preventDefault();
      return false;
    }

    $form.data('isSubmitting', true);
    $btn.prop('disabled', true).addClass('submitting');

    setTimeout(function () {
      $form.data('isSubmitting', false);
      $btn.prop('disabled', false).removeClass('submitting');

      // 再次檢查表單欄位
      $formElement.each(function (e) {
        let $thisInput = $(this);

        formValueVald($thisInput);
      });
    }, 3000);
  });
});